import { render, staticRenderFns } from "./sense.vue?vue&type=template&id=558852d6&scoped=true&"
import script from "./sense.vue?vue&type=script&lang=js&"
export * from "./sense.vue?vue&type=script&lang=js&"
import style0 from "./sense.vue?vue&type=style&index=0&id=558852d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558852d6",
  null
  
)

export default component.exports